<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-address-card" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="lead-title">{{ name }}</div>
            <div class="meta" v-if="lead.email"><i class="far fa-fw fa-envelope mr-2"></i>{{ lead.email }}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <!-- Compact status marks — full-text tag lives on the Lead card. -->
                <span class="stat status-mark" v-if="lead.converted_at" title="Converted"><i class="fas fa-check-circle has-text-success"></i></span>
                <span class="stat status-mark" v-else-if="lead.lost_at" title="Did not convert"><i class="fas fa-ban has-text-danger"></i></span>
                <span class="stat"><b-tag>{{ lead.source }}</b-tag></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="data-table">
                <toolbar class="toolbar">
                    <button class="icon-only" @click.stop="$openCard('lead', {leadId: lead.id}, card)"><i class="far fa-address-card"></i></button>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="Phone">{{ lead.phone }}</data-row>
                    <data-row mini title="Location">{{ location }}</data-row>
                    <data-row mini title="Club">{{ lead.club }}</data-row>
                    <data-row mini title="Interests">{{ lead.interests }}</data-row>
                    <data-row mini title="Customer" v-if="lead.converted_user">{{ customerName }}</data-row>
                    <data-row mini title="Received">{{ lead.timestamp | moment('MMM Do, YYYY, h:mm a') }}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "../TIER/components/Toolbar";
    import DataRow from "../TIER/components/DataRow";
    import CardListItem from "../TIER/components/CardListItem";

    export default {
        name: 'LeadListItem',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            lead: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            name: function () {
                const n = [this.lead.lastname, this.lead.firstname].filter(Boolean).join(', ');
                return n || this.lead.email || 'Lead';
            },
            location: function () {
                return [this.lead.city, this.lead.state, this.lead.country].filter(Boolean).join(', ');
            },
            customerName: function () {
                const u = this.lead.converted_user;
                if (!u) return '';
                return [u.last_name, u.first_name].filter(Boolean).join(', ') || u.email || ('Customer #' + u.id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    li {
        color: darken($t-primary, 10);

        .lead-title {
            font-size: .9rem;
            font-weight: 700;
            margin-top: 1px;
        }

        .status-mark i {
            font-size: 1rem;
            vertical-align: middle;
        }

        padding: 0.5rem 0;

        .data-table {
            margin-top: 0.5rem;
        }
    }
</style>
